import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.FIT_HOTELS,
    name: "umrah-hotels",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FIT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FIT.PERMISSIONS,
    },
    component: () => import("@/modules/FIT/view/HotelsAndUmrah.vue"),
  },
];

export default routes;
